// The default variants for flags are 'on' and 'off', and default variants for experiments are 'control' and 'treatment'
type DEFAULT_VARIANTS = 'control' | 'treatment' | 'on' | 'off'

// The possible variants for each feature
export type FeatureVariants = {
  email_order_confirmation_aug26: DEFAULT_VARIANTS
  'tile-upsell': DEFAULT_VARIANTS
  christmas: DEFAULT_VARIANTS
  'collage-in-plus': DEFAULT_VARIANTS
  halloween: DEFAULT_VARIANTS
  'art-collection-29-jan-2025': DEFAULT_VARIANTS
  'photo-books': DEFAULT_VARIANTS
  'photo-books-new-badge': DEFAULT_VARIANTS
  'payment-order-bnpl': DEFAULT_VARIANTS
  'size-22x44': DEFAULT_VARIANTS
  'sms-consent': DEFAULT_VARIANTS
  'xl-sizes': DEFAULT_VARIANTS
  'capture-phone-number': DEFAULT_VARIANTS
  referral: DEFAULT_VARIANTS
  'materials-under-frame': DEFAULT_VARIANTS
  'homepage-photo-books-banner': DEFAULT_VARIANTS
  'skip-photo-book-dedup': DEFAULT_VARIANTS
  'deprecated-colored-matting': DEFAULT_VARIANTS
  'skip-survey-with-optional':
    | 'off'
    | 'control'
    | 'no-quiz'
    | 'quiz-with-skip-button'
  'openai-low-quality': DEFAULT_VARIANTS
  'ai-templates-catalog': DEFAULT_VARIANTS
  'ai-templates-aiworkflows-routing': DEFAULT_VARIANTS
  'ai-templates-places': 'off' | 'on' | 'places' | 'travel-posters'
  'ai-templates-vintage-posters': DEFAULT_VARIANTS
  'photo-book-cover-drawer-v2': DEFAULT_VARIANTS
  'frameless-all-sizes': DEFAULT_VARIANTS
  'express-checkout-payment-only': DEFAULT_VARIANTS
  'cart-express-checkout': DEFAULT_VARIANTS
  'stacey-solomon-homepage-hero': DEFAULT_VARIANTS
  'tammin-sursok-homepage-hero': DEFAULT_VARIANTS
  'tia-mowry-landing-page': 'off' | 'control' | 'mixed-sizes' | 'square'
  'multi-product-tiles-hero-video': DEFAULT_VARIANTS
  'multi-product-homepage-desktop': DEFAULT_VARIANTS
  'bundle-communication-v2': DEFAULT_VARIANTS
  'pet-variations-in-plus-v2': DEFAULT_VARIANTS | 'renewed-drawer'
  'canvas-generative-wrap': DEFAULT_VARIANTS
  'photo-books-canada-home': DEFAULT_VARIANTS
  'canada-tariffs-comms': DEFAULT_VARIANTS
  'canvas-as-default-tile': DEFAULT_VARIANTS
  'cart-upsell-bath-time-2': DEFAULT_VARIANTS
  pricing_photo_book_price_tier: DEFAULT_VARIANTS
  'external-wall-designer': DEFAULT_VARIANTS
  'multi-product-homepage-organic': DEFAULT_VARIANTS
  'in-house-vouchers': DEFAULT_VARIANTS
  'header-bag-count-badge': DEFAULT_VARIANTS
  'onboarding-skip-button-us-2': DEFAULT_VARIANTS
  'cart-separate-promise-dates': DEFAULT_VARIANTS
  'cart-holiday-cutoffs': DEFAULT_VARIANTS
  'spanish-landing-page': DEFAULT_VARIANTS
}

export type Feature = keyof FeatureVariants

export type FeatureToVariant = {
  [F in Feature]: FeatureVariants[F]
}

// The variant that will be used if we failed getting variants from the server
export const defaultFeatureVariants: FeatureToVariant = {
  email_order_confirmation_aug26: 'off',
  'tile-upsell': 'off',
  christmas: 'off',
  'collage-in-plus': 'off',
  halloween: 'off',
  'art-collection-29-jan-2025': 'off',
  'photo-books': 'on',
  'photo-books-new-badge': 'off',
  'payment-order-bnpl': 'off',
  'size-22x44': 'off',
  'sms-consent': 'off',
  'xl-sizes': 'off',
  'capture-phone-number': 'off',
  referral: 'off',
  'materials-under-frame': 'off',
  'homepage-photo-books-banner': 'off',
  'skip-photo-book-dedup': 'off',
  'deprecated-colored-matting': 'off',
  'skip-survey-with-optional': 'off',
  'openai-low-quality': 'off',
  'ai-templates-catalog': 'off',
  'ai-templates-aiworkflows-routing': 'off',
  'ai-templates-places': 'off',
  'ai-templates-vintage-posters': 'off',
  'photo-book-cover-drawer-v2': 'off',
  'frameless-all-sizes': 'off',
  'express-checkout-payment-only': 'off',
  'cart-express-checkout': 'off',
  'stacey-solomon-homepage-hero': 'off',
  'tammin-sursok-homepage-hero': 'off',
  'tia-mowry-landing-page': 'off',
  'multi-product-tiles-hero-video': 'off',
  'multi-product-homepage-desktop': 'off',
  'bundle-communication-v2': 'off',
  'pet-variations-in-plus-v2': 'off',
  'canvas-generative-wrap': 'off',
  'photo-books-canada-home': 'off',
  'canada-tariffs-comms': 'off',
  'canvas-as-default-tile': 'off',
  'cart-upsell-bath-time-2': 'off',
  pricing_photo_book_price_tier: 'off',
  'external-wall-designer': 'off',
  'multi-product-homepage-organic': 'off',
  'in-house-vouchers': 'off',
  'header-bag-count-badge': 'off',
  'onboarding-skip-button-us-2': 'off',
  'cart-separate-promise-dates': 'off',
  'cart-holiday-cutoffs': 'off',
  'spanish-landing-page': 'off',
}

// Features evaluated only on the server (e.g. SSR redirects). They never get a client-side
// `variant()` call, so their Amplitude exposure must be triggered manually on the client.
export const SERVER_EVALUATED_FEATURES: Feature[] = [
  'materials-under-frame',
  'multi-product-homepage-organic',
  'tia-mowry-landing-page',
]
